import { useEffect } from 'react';

/** Call a function when a key is pressed */
export default function useKeyPress({ keyCode, shouldListen, callback }) {
  useEffect(() => {
    function downHandler(event) {
      if (event.keyCode === keyCode) callback();
    }
    if (shouldListen) window.addEventListener('keydown', downHandler);
    return () => window.removeEventListener('keydown', downHandler);
  }, [callback, keyCode, shouldListen]);
}
